import { numberMoney } from 'Data/format.js'

export function getText(charge_templates) {
  let total = charge_templates.reduce((acc, charge) => acc + charge.amount, 0)
  return numberMoney(total)
}
